import Image from 'next/image';

export const HowToMeasureItem = ({
  image,
  title,
  description,
}: {
  image: string;
  title: string;
  description: string;
}) => {
  return (
    <div>
      <Image
        className='mb-[20px] h-[185px] w-[240px]'
        src={image}
        alt={title}
        width={240}
        height={185}
      />

      <div className='mb-[10px] font-roboto-medium text-[18px] font-medium'>{title}</div>
      <div className='font-roboto-light text-[16px] font-light leading-[26px]'>{description}</div>
    </div>
  );
};

export const HowToMeasure1 = () => {
  return (
    <div className='mt-[60px]'>
      <h3 className='mb-[40px]  font-roboto-medium text-[20px] font-medium capitalize leading-[28px] text-primary'>
        how to measure
      </h3>
      <div className='grid grid-cols-1 gap-[46px] lg_grid-cols-4 lg_gap-[50x] '>
        {[
          {
            image: '/contact-us/measure-1.png',
            title: 'Step 1',
            description:
              'Put on socks that you will most likely use with the footwear. It is better to take the measurements during the afternoon or evening.',
          },
          {
            image: '/contact-us/measure-2.png',
            title: 'Step 2',
            description:
              'Place a blank sheet of paper on a flat surface, against a wall or other 90 degree surface. Place foot on the paper, heel against the wall.',
          },
          {
            image: '/contact-us/measure-3.png',
            title: 'Step 3',
            description:
              'Mark the end of the longest toe with a pen or pencil. Measure both feet in centimetre/inch and use the larger measurement between the two feet.',
          },
          {
            image: '/contact-us/measure-4.png',
            title: 'Step 4',
            description:
              'Read your measurement and compare to the Size Chart here. When comparing to the chart, use the closest larger measurement to determine your size.',
          },
        ].map((item, index) => (
          <HowToMeasureItem
            key={index}
            {...item}
          />
        ))}
      </div>
    </div>
  );
};
